import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Pagination,
  Drawer,
  Button,
  Form,
  Input,
  Switch,
  Popconfirm,
  Space,
  Select,
} from 'antd';
import { AgGridReact } from 'ag-grid-react';

import JoditEditor from '../../molecules/JoditEditor';
import SearchBar from '../../templates/SearchBar';
import StyledDrawer from '../../atoms/StyledDrawer';

const { Option } = Select;

function QnaAnswerView({
  form,
  list,
  paging,
  visible,
  isEdit,
  columnDefs,
  gridOptions,
  searchOption,
  onPaging,
  onRowClick,
  onCellClick,
  onGridReady,
  onDraw,

  onFinish,
  onReset,
  onSearch,
  onMoveList,
  onGridSizeChanged,
}) {
  return (
    <div>
      <Row>
        <Col span={24}>
          <Row style={{ marginBottom: 10 }}>
            <Col span={18}>
              {/* SearchBar */}
              <SearchBar options={searchOption} onSearch={onSearch} />
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              <Space>{/* buttons */}</Space>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="ag-theme-alpine" style={{ height: 470 }}>
            <AgGridReact
              rowData={list}
              columnDefs={columnDefs}
              {...gridOptions}
              onGridReady={onGridReady}
              onRowClicked={onRowClick}
              onCellClicked={onCellClick}
              onGridSizeChanged={onGridSizeChanged}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ padding: 20, textAlign: 'center' }}>
          <Pagination
            pageSize={paging?.pageSize ?? 10}
            current={paging?.currentPageNo ?? 1}
            total={paging?.totalRecordCount ?? 0}
            onChange={onPaging}
          />
        </Col>
      </Row>
      <StyledDrawer
        title={`답변관리 ${isEdit ? '수정' : '등록'}`}
        placement="right"
        width="40vw"
        open={visible}
        onClose={() => {
          onDraw(false);
          onMoveList();
        }}
        footer={[
          <Row align="middle" justify="space-between">
            <Col>
              <Button
                key="btn2"
                disabled={isEdit}
                htmlType="button"
                onClick={() => {
                  onReset(isEdit);
                }}
              >
                초기화
              </Button>
            </Col>
            <Col>
              <Space>
                <Popconfirm
                  key="btn1"
                  title="저장 하시겠습니까?"
                  placement="topRight"
                  onConfirm={() => {
                    form.submit();
                  }}
                  onCancel={() => {}}
                  okText="저장"
                  cancelText="취소"
                >
                  <Button
                    type="primary"
                    htmlType="button"
                    // onClick={() => form.submit()}
                  >
                    저장
                  </Button>
                </Popconfirm>
                <Button
                  key="btn3"
                  onClick={() => {
                    onDraw(false);
                    onMoveList();
                  }}
                >
                  닫기
                </Button>
              </Space>
            </Col>
          </Row>,
        ]}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          {/* Hidden Value */}
          <Form.Item name="qaId" noStyle>
            <Input hidden />
          </Form.Item>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="작성자명" className="form-item__text">
                {form.getFieldValue('wrterNm')}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="연락처" className="form-item__text">
                {form.getFieldValue('areaNo')}-
                {form.getFieldValue('middleTelno')}-
                {form.getFieldValue('endTelno')}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="이메일" className="form-item__text">
                {form.getFieldValue('emailAdres')}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="
                이메일답변여부"
                name="emailAnswerAt"
                valuePropName="checked"
              >
                <Switch disabled={isEdit} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="등록일" className="form-item__text">
                {form.getFieldValue('frstRegisterPnttm')}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="진행상태"
                name="qnaProcessSttusCode"
                rules={[
                  { required: true, message: '진행상태를 선택해주세요.' },
                ]}
              >
                <Select>
                  <Option value="1">접수대기</Option>
                  <Option value="2">접수</Option>
                  <Option value="3">완료</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="질문 제목" className="form-item__text">
                {form.getFieldValue('qestnSj')}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="질문 내용" name="qestnCn">
                <JoditEditor visible={visible} removeButtons={['image']} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="답변 내용"
                name="answerCn"
                rules={[
                  { required: true, message: '답변 내용을 입력해주세요.' },
                ]}
                tooltip="답변 내용을 입력해주세요."
              >
                <JoditEditor visible={visible} removeButtons={['image']} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </StyledDrawer>
    </div>
  );
}

QnaAnswerView.propTypes = {
  form: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  ),
  list: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    ),
  ),
  paging: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
  visible: PropTypes.bool,
  columnDefs: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.object,
        PropTypes.func,
      ]),
    ),
  ),
  gridOptions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.func,
    PropTypes.object,
  ]),
  isEdit: PropTypes.bool,
  searchOption: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  ),
  onPaging: PropTypes.func,
  onGridReady: PropTypes.func,
  onRowClick: PropTypes.func,
  onCellClick: PropTypes.func,
  onDraw: PropTypes.func,

  onFinish: PropTypes.func,
  onReset: PropTypes.func,
  onSearch: PropTypes.func,
  onMoveList: PropTypes.func,
  onGridSizeChanged: PropTypes.func,
};

QnaAnswerView.defaultProps = {
  form: {},
  list: [],
  paging: {},
  visible: false,
  columnDefs: [],
  gridOptions: {},
  isEdit: false,
  searchOption: {},
  onPaging: () => {},
  onGridReady: () => {},
  onRowClick: () => {},
  onCellClick: () => {},
  onDraw: () => {},

  onFinish: () => {},
  onReset: () => {},
  onSearch: () => {},
  onMoveList: () => {},
  onGridSizeChanged: () => {},
};

export default QnaAnswerView;
